// extracted by mini-css-extract-plugin
export default {"root":"IconCart_root__9R+1I","small":"IconCart_small__VV0Fu","medium":"IconCart_medium__0biOB","large":"IconCart_large__LQs5R","xlarge":"IconCart_xlarge__p0Ymg"};